import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { ExtractFromLoadService } from '../extract-from-load.service';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
@Component({
  selector: "app-extract",
  templateUrl: "./extract.component.html",
  styleUrls: ["./extract.component.scss"],
})
export class ExtractComponent implements OnInit {
  instanceList: any;
  selectedInstance: any;
  public projectId: string;
  public projectName: string;
  editBtnDisable: boolean = false;
  public batchKey: string;
  public options: any;
  public tracks = [];
  public configData = [];
  public showArray = [];
  batchKeyDetails: any;
  public itemNumber = 3;
  fromTable: any = null;
  public progressBarName = "extract";
  public progressBarArray1: any = [
    { name: "select", src: "assets/complete.png", index: 0 },
    { name: "submit", src: "assets/complete.png", index: 1 },
    { name: "parameters", src: 'assets/complete.png', index: 2 },
    { name: "extract", src: 'assets/extract.png', index: 3 }
  ];
  totalSelectedTask: number = 0;

  constructor(
    public dialog: MatDialog,
    private celService: ExtractFromLoadService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NotificationService,
    private _data: DataService
  ) { }

  ngOnInit(): void {
    if (this.celService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      if (this.celService.fromTable) {
        this.batchKeyDetails = this.celService.batchKeyDetails;
        this.getInstanceDetails(DconConfigAPI.API_VARIABLES.CLOUD);
        this.batchKey = this.celService.batchKey;
        this.projectId = this.celService.projId;
        this.getTracks(this.batchKeyDetails);
        this.setShowArray();
        this.fromTable = this.celService.fromTable;
        this.calculateSelectedTasks(this.batchKeyDetails);
      } else {
        this.instanceList = this.celService.instanceList;
        this.selectedInstance = this.celService.instanceName;
        this.batchKey = this.celService.batchKey;
        this.projectId = this.celService.projId;
        this.tracks = this.celService.configObj.tracks;
        this.configData = this.celService.configObj.configData;
        this.calculateSelectedTasks(this.configData);
        this.setShowArray();
      }
    }
  }

  setShowArray() {
    this.tracks.forEach((val1, index) => {
      this.showArray[index] = false;
    });
  }

  calculateSelectedTasks(configData) {
    this.totalSelectedTask = 0;
    configData.forEach((config) => {
      if (config.saveStatus) {
        if (this.fromTable) {
          this.totalSelectedTask = this.totalSelectedTask + config.linedetail.filter((elem) => elem.taskselected === "Y").length;
        } else {
          this.totalSelectedTask = this.totalSelectedTask + config.TASK.filter((elem) => elem.selectStatus === "y").length;
        }
      }
    });
  }

  onInstanceChange(instance) { }

  onExtractClick() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    const data = [];
    this.celService.getExtractDetails().subscribe((res) => {
      // this.count = 0;
      const obj = {
        startInfo: {
          ReleaseKey: res.value[0].Key,
          Strategy: "JobsCount",
          RobotIds: [],
          JobsCount: 1,
          Source: "Manual",
          InputArguments: JSON.stringify({ Batchkey: this.batchKey, RequestedBy: this._data.loggedUserId }),
        }
      };

      this.celService.onExtract(obj).subscribe((resp) => {
        if (resp.value[0].Id != null) {
          const body = {
            "batchkey": this.batchKey,
            "requesttype": DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
            "processtrigger": "Y"
          };
          this.celService.onExtractUpdate(body).subscribe(() => {
            this.extractPopUp();
            this.unMaskPage();
          }, error => {
            this.unMaskPage();
            this.notification.showError('Something went wrong!');
          });
        }
      }, error => {
        this.unMaskPage();
        this.notification.showError('Something went wrong!');
      });
    }, error => {
      // this.count++
      // if(error.status == 401 && error.error.message == "You are not authenticated!" && this.count <= 1){
      if (error.status === 401) {
        this.unMaskPage();
        this.notification.showError('Session Expired!');
        this.router.navigate([""], { relativeTo: this.route });
        // this.getAuthToken();
      } else {
        this.unMaskPage();
        this.notification.showError('Something went wrong!');
        this.router.navigate([""], { relativeTo: this.route });
      }
    });
  }

  // getAuthToken(){
  //   let creds = this.celService.getuipathCreds()
  //   const body = {
  //     tenancyName: DconConfigAPI.TENANCY_NAME,
  //     usernameOrEmailAddress: creds.username,
  //   };
  //   this.celService.callUiPathAuthApi(body).subscribe((resdata: any) => {
  //        let tokData = resdata?.result;
  //        this.celService.authToken = 'Bearer ' + tokData;
  //       this._data.token.next(tokData);
  //       this._data.authToken = tokData;
  //       this.unMaskPage();
  //       this.onExtractClick();
  //     },
  //     (error) => {
  //       this.unMaskPage();
  //       this.notification.showError('Something went wrong!');
  //     }
  //   );
  // }


  extractPopUp() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: "Task Status",
        mess: `Batch Key ${this.batchKey}  <b>: Cloud Extraction - Process Submitted </b>`,
        estimatedTime: `Estimated execution time ${this.totalSelectedTask * 3} minutes`
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if ((result = "ok")) {
        this.router.navigate(["/cloud-extract"]);
      }
    });
  }

  configPopUp(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configData);
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        this.celService.tabval.next("submit");
        this.router.navigate(["../submit"], { relativeTo: this.route });
      } else {
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (
        selConfigData.TRACK == element.TRACK && selConfigData.APPLICATION == element.APPLICATION &&
        selConfigData.APPLICATION_SHORT_CODE == element.APPLICATION_SHORT_CODE
      ) {
        this.configData.splice(index, 1, selConfigData);
      }
    });
  }

  configPopUpEdit(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigDataEdit(result, this.batchKeyDetails);
        this.celService.tracksFromTable = this.tracks;
        this.celService.batchKeyDetails = this.batchKeyDetails;
        this.celService.tabval.next("submit");
        this.router.navigate(["../submit"], { relativeTo: this.route });
      } else {
        this.celService.tracksFromTable = this.tracks;
        this.celService.batchKeyDetails = this.batchKeyDetails;
      }
    });
  }

  setSelectedconfigDataEdit(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (
        selConfigData.track == element.track && selConfigData.application == element.application && selConfigData.applicationshortcode == element.applicationshortcode
      ) {
        this.batchKeyDetails.splice(index, 1, selConfigData);
      }
    });
  }

  editConfig() {
    if (this.fromTable) {
      this.tracks.forEach((val1, index) => {
        this.batchKeyDetails.forEach((val2, index2) => {
          if (val1 === val2.track && val2.saveStatus) {
            this.showArray[index] = true;
          }
        });
      });
    } else {
      this.tracks.forEach((val1, index) => {
        this.configData.forEach((val2, index2) => {
          if (val1 === val2.TRACK && val2.saveStatus) {
            this.showArray[index] = true;
          }
        });
      });
    }

    this.editBtnDisable = true;
    this.celService.tracksFromTable = this.tracks;
    this.celService.instanceList = this.instanceList;
    this.celService.instanceName = this.selectedInstance;
  }

  getInstanceDetails(type) {
    const data = [];
    this.celService.getInstanceDetails(type).subscribe((res) => {
      res?.Instance_Details?.forEach((element) => {
        data.push(JSON.parse(element.details));
      });
      this.instanceList = data[0].INSTANCE;
      this.instanceList.forEach((element) => {
        if (element.INSTANCE_ID === this.batchKeyDetails[0].instanceid) {
          this.selectedInstance = element;
        }
      });
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }

  getTracks(data) {
    data.forEach((element, index) => {
      this.tracks.push(element.track);
    });
    this.tracks = [...new Set(this.tracks)];
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }
}
